import React, { useState } from 'react';
import './TsContasolLanding.css';

const TsContasolLanding = () => {
    // --- LÓGICA DEL FORMULARIO (INTOCABLE - NO MODIFICAR) ---
    const [selectedPlan, setSelectedPlan] = useState('B');
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    const [errorMessage, setErrorMessage] = useState('');

    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan);
        const formElement = document.getElementById('contact-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        const formData = new FormData(e.target);
        
        // Mapeo para enviar nombre descriptivo al backend
        const planNames = {
            'A': 'Plan Base (2.150€)',
            'B': 'Plan Profesional (2.790€)',
            'C': 'Plan Enterprise (3.650€)'
        };

        const data = {
            form_id: 'ts-contasol',
            plan: planNames[selectedPlan] || selectedPlan,
            name: formData.get('name'),
            company: formData.get('company'),
            email: formData.get('email'),
            phone: formData.get('phone'),
            software: formData.get('software'),
            volume: formData.get('volume'), 
            message: formData.get('message'),
            hp: formData.get('b_name'), // Honeypot
            website: 'datados.es'
        };

        try {
            const response = await fetch('https://datados.es/api/contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (result.ok) {
                setStatus('success');
            } else {
                setErrorMessage(result.error || 'Error al enviar el formulario.');
                setStatus('error');
            }
        } catch (error) {
            setErrorMessage('Error de conexión con el servidor.');
            setStatus('error');
        }
    };
    // --- FIN LÓGICA INTOCABLE ---

    return (
        <div className="ts-container">
            
            {/* 1. HERO INSTITUCIONAL */}
            <header className="ts-hero">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <h1>Contabilidad migrada con control total desde el primer día</h1>
                            <p className="ts-hero-subtitle">
                                Regularizamos y migramos tus datos hacia TS Contasol con verificación cruzada con TS Factusol, asegurando coherencia real entre ventas, proveedores y contabilidad.
                            </p>
                            
                            <div className="ts-hero-features">
                                <div className="ts-feature-item">
                                    <span className="ts-check">✓</span> Datos contables verificados.
                                </div>
                                <div className="ts-feature-item">
                                    <span className="ts-check">✓</span> Factusol y Contasol sincronizados.
                                </div>
                                <div className="ts-feature-item">
                                    <span className="ts-check">✓</span> Control total de tu información contable.
                                </div>
                            </div>

                            <button onClick={() => document.getElementById('contact-form').scrollIntoView({ behavior: 'smooth' })} className="ts-btn-primary">
                                Recibir propuesta personalizada
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* 2. DIFERENCIA CLAVE: IMPORTACIÓN ESTÁNDAR VS PERSONALIZADA */}
            <section className="ts-section ts-bg-gray">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <h2 className="text-center mb-5">¿Por qué una simple importación no es suficiente?</h2>

                            <div className="row g-4 ts-compare-row">
                                {/* Columna izquierda */}
                                <div className="col-md-6">
                                    <div className="ts-compare-card ts-compare-card--left">
                                        <div className="ts-compare-header">
                                            <h3 className="ts-compare-title">Importación estándar</h3>
                                            <p className="ts-compare-subtitle">Rápida, pero sin garantías reales.</p>
                                        </div>

                                        <ul className="ts-compare-list">
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--bad">✕</span>
                                                Se trasladan datos sin validar, pudiendo arrastrar errores ocultos.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--bad">✕</span>
                                                Las inconsistencias suelen aparecer meses después, cuando ya estás operando.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--bad">✕</span>
                                                No garantiza alineación real entre ventas, proveedores y contabilidad.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--bad">✕</span>
                                                No está pensada para consolidar varios ejercicios históricos.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--bad">✕</span>
                                                Menos control: dependes de correcciones manuales posteriores.
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Columna derecha */}
                                <div className="col-md-6">
                                    <div className="ts-compare-card ts-compare-card--right">
                                        <div className="ts-compare-header">
                                            <h3 className="ts-compare-title">Importación contable personalizada</h3>
                                            <p className="ts-compare-subtitle">Validada antes de entrar en producción.</p>
                                        </div>

                                        <ul className="ts-compare-list">
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--good">✓</span>
                                                Los datos se revisan antes de migrar, evitando trasladar errores al nuevo sistema.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--good">✓</span>
                                                Factusol y Contasol sincronizados con coherencia real.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--good">✓</span>
                                                Ideal para varios ejercicios y consolidación histórica.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--good">✓</span>
                                                Estructura preparada para crecimiento, reportes y revisiones futuras.
                                            </li>
                                            <li>
                                                <span className="ts-compare-icon ts-compare-icon--good">✓</span>
                                                Más control y tranquilidad para que el asesor trabaje “sobre seguro”.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


            {/* 3. AUTORIDAD Y METODOLOGÍA */}
            <section className="ts-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <h2 className="mb-3">Cómo garantizamos una migración sin sorpresas</h2>
                            <p className="ts-section-subtitle">
                                Experiencia, entorno controlado y un proceso diseñado para que tú no tengas que preocuparte de nada.
                            </p>
                        </div>
                    </div>

                    <div className="row g-4 mt-4">
                        {/* Columna izquierda */}
                        <div className="col-md-6">
                            <div className="ts-authority-card">
                                <h3 className="ts-authority-title">Expertos que migran tus datos</h3>
                                <ul className="ts-authority-list">
                                    <li>Desarrolladores registrados en el ecosistema TS Factusol y TS Contasol.</li>
                                    <li>Acceso a entornos oficiales de prueba para validar antes de producción.</li>
                                    <li>Experiencia trabajando con grandes volúmenes de facturación y contabilidad.</li>
                                    <li>Especialización en integración entre TS Factusol y TS Contasol.</li>
                                    <li>Enfoque profesional orientado a empresas.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Columna derecha */}
                        <div className="col-md-6">
                            <div className="ts-authority-card">
                                <h3 className="ts-authority-title">Cómo lo hacemos por ti</h3>
                                <ul className="ts-authority-list">
                                    <li>Nos encargamos de todo el proceso técnico sin que tengas que intervenir.</li>
                                    <li>Migración validada antes de entrar en producción.</li>
                                    <li>Sistema entregado listo para trabajar desde el primer día.</li>
                                    <li>Coordinación directa con tu asesor si es necesario.</li>
                                    <li>Proceso rápido, controlado y con seguimiento posterior.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* 4. PLANES (ACTUALIZADOS Y ENRIQUECIDOS) */}
            <section className="ts-section ts-bg-gray">
                <div className="container">
                    <h2 className="text-center mb-5">Propuesta de Servicios de Regularización</h2>
                    
                    <div className="row g-0 align-items-stretch justify-content-center ts-pricing-row">
                        
                        {/* PLAN A - BASE */}
                        <div className="col-lg-4 col-md-6">
                            <div className={`ts-card ts-card-side ${selectedPlan === 'A' ? 'active-selection' : ''}`}>
                                <h3 className="ts-plan-title">Plan Base</h3>
                                <div className="ts-price">2.150€ <small>/proyecto</small></div>
                                <p className="ts-plan-desc">Solución ágil para estructuras simples.</p>
                                <hr />
                                <ul className="ts-list-pricing">
                                    <li>Hasta 1 sociedad</li>
                                    <li>Hasta 2 ejercicios</li>
                                    <li>Revisión estructural inicial</li>
                                    <li>Adaptación a formato de importación</li>
                                    <li>Importación asistida</li>
                                    <li>Soporte técnico 7 días</li>
                                </ul>
                                <button onClick={() => handlePlanSelect('A')} className="ts-btn-outline w-100 mt-auto">
                                    Solicitar información
                                </button>
                            </div>
                        </div>

                        {/* PLAN B - PROFESIONAL (DESTACADO + ENRIQUECIDO) */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ts-card ts-card-center">
                                <div className="ts-badge-rec">Recomendado ⭐</div>
                                <h3 className="ts-plan-title">Plan Profesional</h3>
                                <div className="ts-price">2.790€ <small>/proyecto</small></div>
                                <p className="ts-plan-desc">Estándar corporativo de validación integral.</p>
                                <hr />
                                <ul className="ts-list-pricing">
                                    <li><strong>Hasta 2 sociedades</strong></li>
                                    <li>Hasta 6 ejercicios históricos</li>
                                    <li>Validación estructural integral</li>
                                    <li>Homogeneización de auxiliares</li>
                                    <li>Normalización de referencias PGC</li>
                                    <li>Verificación cruzada con entorno TS Factusol</li>
                                    <li>Control de errores en tiempo real</li>
                                    <li>Checklist de verificación final</li>
                                    <li>Documentación técnica resumida</li>
                                    <li><strong>Soporte ampliado 30 días</strong></li>
                                </ul>
                                <button onClick={() => handlePlanSelect('B')} className="ts-btn-primary w-100 mt-auto">
                                    Solicitar información
                                </button>
                            </div>
                        </div>

                        {/* PLAN C - ENTERPRISE (ENRIQUECIDO) */}
                        <div className="col-lg-4 col-md-6">
                            <div className={`ts-card ts-card-side ${selectedPlan === 'C' ? 'active-selection' : ''}`}>
                                <h3 className="ts-plan-title">Plan Enterprise</h3>
                                <div className="ts-price">3.650€ <small>/proyecto</small></div>
                                <p className="ts-plan-desc">Arquitectura avanzada para entornos complejos.</p>
                                <hr />
                                <ul className="ts-list-pricing">
                                    <li>Multisociedad</li>
                                    <li>Hasta 10 ejercicios históricos</li>
                                    <li>Validación transversal con hasta 3 soluciones TeamSystem</li>
                                    <li>Optimización avanzada del plan contable</li>
                                    <li>Estructuración multiempresa</li>
                                    <li>Arquitectura contable integral</li>
                                    <li>Consultoría de flujo de datos</li>
                                    <li>Acompañamiento en apertura</li>
                                    <li>Validación multi-entorno productivo</li>
                                    <li>Coordinación técnica con asesor fiscal</li>
                                    <li><strong>Soporte post-implantación 60 días</strong></li>
                                </ul>
                                <button onClick={() => handlePlanSelect('C')} className="ts-btn-outline w-100 mt-auto">
                                    Solicitar información
                                </button>
                            </div>
                        </div>

                    </div>
                    <p className="text-center mt-4 text-muted small">Precios sin impuestos indirectos. IGIC/IVA aplicable según territorio fiscal.</p>
                </div>
            </section>

            {/* 5. METODOLOGÍA TÉCNICA */}
            <section className="ts-section">
                <div className="container">
                    <h2 className="text-center mb-5">Protocolo de Ejecución</h2>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="ts-timeline">
                                <div className="ts-timeline-item">
                                    <span className="ts-step-num">01</span>
                                    <h4>Diagnóstico</h4>
                                    <p>Análisis de la salud de los datos de origen y estructura de ficheros.</p>
                                </div>
                                <div className="ts-timeline-item">
                                    <span className="ts-step-num">02</span>
                                    <h4>Normalización</h4>
                                    <p>Alineación con el Plan Contable objetivo y corrección de sintaxis.</p>
                                </div>
                                <div className="ts-timeline-item">
                                    <span className="ts-step-num">03</span>
                                    <h4>Validación</h4>
                                    <p>Pruebas de integridad y cuadres automáticos pre-migración.</p>
                                </div>
                                <div className="ts-timeline-item">
                                    <span className="ts-step-num">04</span>
                                    <h4>Adaptación</h4>
                                    <p>Preparación de estructuras compatibles con el destino.</p>
                                </div>
                                <div className="ts-timeline-item">
                                    <span className="ts-step-num">05</span>
                                    <h4>Implantación</h4>
                                    <p>Migración técnica al entorno de producción.</p>
                                </div>
                                <div className="ts-timeline-item">
                                    <span className="ts-step-num">06</span>
                                    <h4>Verificación</h4>
                                    <p>Auditoría post-salida y entrega de informe de cierre.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 6. GARANTÍA Y CREDENCIALES */}
            <section className="ts-section ts-bg-light-blue text-center">
                <div className="container">
                    <p className="ts-label-upper">Garantía Técnica</p>
                    <div className="d-flex flex-wrap justify-content-center gap-4 align-items-center mt-3">
                        <span className="ts-credential">Compatible con toda la suite TeamSystem Software DELSOL</span>
                        <div className="ts-vr"></div>
                        <span className="ts-credential">Desarrollador registrado en ecosistema API</span>
                        <div className="ts-vr"></div>
                        <span className="ts-credential">Experiencia en tratamiento masivo de datos contables</span>
                    </div>
                </div>
            </section>

            {/* 7. FORMULARIO (LÓGICA INTACTA) */}
            <section id="contact-form" className="ts-section container mb-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="ts-form-container">
                            <h2 className="text-center mb-4">Iniciar consulta técnica</h2>
                            
                            {status === 'success' ? (
                                <div className="text-center py-5">
                                    <div className="h2 text-success mb-3">✓ Solicitud Registrada</div>
                                    <p className="lead">Hemos recibido sus datos correctamente.</p>
                                    <p>El departamento técnico analizará su caso y contactará a través de <strong>info@datados.es</strong>.</p>
                                    <button onClick={() => setStatus('idle')} className="btn btn-link mt-3">Nueva consulta</button>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    {/* Honeypot */}
                                    <input type="text" name="b_name" style={{ display: 'none' }} tabIndex="-1" autoComplete="off" />
                                    
                                    <div className="row">
                                        <div className="col-md-6 mb-4">
                                            <label className="ts-label">Nombre completo</label>
                                            <input type="text" name="name" className="ts-input" required />
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <label className="ts-label">Empresa / Razón Social</label>
                                            <input type="text" name="company" className="ts-input" required />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-4">
                                            <label className="ts-label">Email corporativo</label>
                                            <input type="email" name="email" className="ts-input" required />
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <label className="ts-label">Teléfono directo</label>
                                            <input type="tel" name="phone" className="ts-input" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-4">
                                            <label className="ts-label">Plan de interés</label>
                                            <select 
                                                className="ts-select" 
                                                name="plan" 
                                                value={selectedPlan} 
                                                onChange={(e) => setSelectedPlan(e.target.value)}
                                            >
                                                <option value="A">Plan Base (2.150€)</option>
                                                <option value="B">Plan Profesional (2.790€)</option>
                                                <option value="C">Plan Enterprise (3.650€)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <label className="ts-label">Software de origen</label>
                                            <input type="text" name="software" className="ts-input" placeholder="Ej: Excel, Sage, A3..." />
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="ts-label">Mensaje / Requerimientos específicos</label>
                                        <textarea name="message" className="ts-input" rows="4"></textarea>
                                    </div>

                                    {status === 'error' && (
                                        <div className="alert alert-danger mb-4 small">{errorMessage}</div>
                                    )}

                                    <button 
                                        type="submit" 
                                        className="ts-btn-primary w-100 py-3" 
                                        disabled={status === 'loading'}
                                    >
                                        {status === 'loading' ? 'Procesando solicitud...' : 'Enviar solicitud de información'}
                                    </button>
                                    
                                    <p className="text-center mt-3 ts-legal-text">
                                        Al enviar este formulario, acepta el tratamiento de datos para fines profesionales y de contacto técnico.
                                    </p>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TsContasolLanding;